import { TSmartContract } from "@/types";
import { PREFIX_SCM_PATH } from "../constant/path";

export const CONTRACT_API = {
  urlGetContract: (type: TSmartContract | string, chainId: string) =>
    `${PREFIX_SCM_PATH}/smart_contract/${type}/${chainId}`,
};
